var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUser3Line = function SvgUser3Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19.7 21.002h-1.8v-1.8a2.7 2.7 0 0 0-2.7-2.7H9.8a2.7 2.7 0 0 0-2.7 2.7v1.8H5.3v-1.8a4.5 4.5 0 0 1 4.5-4.5h5.4a4.5 4.5 0 0 1 4.5 4.5zm-7.2-8.1a5.4 5.4 0 1 1 0-10.8 5.4 5.4 0 0 1 0 10.8m0-1.8a3.6 3.6 0 1 0 0-7.2 3.6 3.6 0 0 0 0 7.2"
  })));
};
export default SvgUser3Line;